import { render, staticRenderFns } from "./InventoryDetail4IMEI.vue?vue&type=template&id=56c944e0"
import script from "./InventoryDetail4IMEI.vue?vue&type=script&lang=js"
export * from "./InventoryDetail4IMEI.vue?vue&type=script&lang=js"
import style0 from "./InventoryDetail4IMEI.vue?vue&type=style&index=0&id=56c944e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports